var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.61 7.17a2.51 2.51 0 0 0-1.77-1.77C18.28 5 12 5 12 5s-6.22 0-7.78.4a2.51 2.51 0 0 0-1.77 1.77A26 26 0 0 0 2 12a25.87 25.87 0 0 0 .42 4.81 2.51 2.51 0 0 0 1.77 1.77C5.78 19 12 19 12 19s6.25 0 7.81-.42a2.51 2.51 0 0 0 1.77-1.77A25.87 25.87 0 0 0 22 12a26 26 0 0 0-.39-4.83ZM10 15V9l5.2 3Z"
})));
export default SvgYoutube;